<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div class="elem-align-center">
    <h3>Are you sure you want to delete below groups?</h3>
  </div>
  <table class="table table-hover table-bordered table-condensed elem-align-center custom-table">
    <thead>
      <tr>
        <th colspan="2">GROUP NAME</th>
      </tr>
    </thead>
    <tbody>
      @for (group of allSelectedGroups; track $index) {
<tr>
        <td colspan="2">
          <input type="text" [ngModel]="group.GROUP_NAME" class="form-control input-sm subtableRowHeight" readonly>
        </td>
      </tr>
}
    </tbody>
  </table>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="delete-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="deleteGroups()">
    Delete Groups
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
  </button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
